import React from 'react';
import {useDispatch} from 'react-redux';
import {openModal} from '../../actions';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'garageName',
    numeric: false,
    disabledPadding: true,
    label: 'Garages',
  },
  {
    id: 'siteCode',
    numeric: false,
    disabledPadding: false,
    label: 'Site code',
  },
  {
    id: 'converted',
    numeric: false,
    disabledPadding: false,
    label: 'Converted',
  },
  {
    id: 'siteNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Site number',
  },
  {
    id: 'carPlates',
    numeric: false,
    disabledPadding: false,
    label: 'Car plates',
  },
  {
    id: 'createdBy',
    numeric: false,
    disabledPadding: false,
    label: 'Created by',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
];

const DATA_CELLS = [
  'garageName',
  'siteCode',
  'converted',
  'siteNumber',
  'carPlates',
  'createdBy',
  'createdAt',
];

// Report-only garage data on a customer. Clicking a row opens it for editing.
const CustomerGaragesTable = ({garages, onAdd, customerId}) => {
  const dispatch = useDispatch();

  const onRowClick = row => {
    dispatch(
      openModal('EditCustomerGarageModal', {customerId, customerGarage: row}),
    );
  };

  return (
    <Table
      data={garages}
      tableName="Garages"
      headCells={HEAD_CELLS}
      dataCells={DATA_CELLS}
      onAdd={onAdd}
      onRowClick={onRowClick}
      getObject
      noSort
    />
  );
};

export default CustomerGaragesTable;
